import { Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import IntegrationsScreen from './integration';
import GoogleDriveIntegration from './googleDriveIntegration';
import WhatsappIntegration from './whatsappIntegration';
import InstagramIntegration from './instagramIntegration';
 
const Integrations = () => {
  const [t] = useTranslation('integration');

  return (
    <div className="mx-auto h-fit w-full max-w-[1200px] px-0 pt-20 md:px-8">
      <h1 className="text-2xl font-bold">{t('title')}</h1>
      <h4  className="mb-5">{t('integration_description')}</h4>

      <div className="mb-24 h-[70vh] w-full overflow-y-scroll rounded-2xl bg-base-100 p-6 lg:mb-0">
        <Routes>
          <Route path="" element={<IntegrationsScreen />} />
          <Route path="" element={<IntegrationsScreen />} />

          <Route path="google_drive" element={<GoogleDriveIntegration />} />
          <Route path="wsp_success" element={<WhatsappIntegration />} />
          <Route path="instagram" element={<InstagramIntegration />} />

 
        </Routes>
      </div>
    </div>
  );
};

export default Integrations;
